import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  Divider,
  Box,
  Button,
  Heading,
  DrawerOverline,
  VStack,
  DrawerCloseButton,
} from '@frontend/legacy-components';

import SelectVideoButton from './SelectVideoButton';
import {
  useAdditionalResourceVideosQuery,
  usePageVideosQuery,
} from './data/queries';
import { maybeCreateCategory } from './helpers';

const PageSpecificContentDrawer = ({
  pageId,
  isOpen,
  onClose,
  onVideoSelect,
}) => {
  const pageVideosQuery = usePageVideosQuery(pageId, {
    enabled: !!pageId,
    refetchOnWindowFocus: false,
  });
  const additionalResourcesVideosQuery = useAdditionalResourceVideosQuery(
    pageId,
    { enabled: !!pageId, refetchOnWindowFocus: false },
  );

  const videoCategories = [
    ...maybeCreateCategory('Page Intro Video', pageVideosQuery.data?.video),
    ...maybeCreateCategory(
      'Page Specific Content',
      additionalResourcesVideosQuery.data
        ? additionalResourcesVideosQuery.data.map((v) => v.video)
        : null,
    ),
  ];

  return (
    <Drawer size="md" isOpen={isOpen} onClose={onClose}>
      <DrawerContent>
        <DrawerHeader>
          <DrawerOverline>Help</DrawerOverline>
          Help for This Page
          <DrawerCloseButton />
        </DrawerHeader>
        <DrawerBody pb={0} pt={0}>
          {videoCategories.length
            ? videoCategories.map((category, index) => (
                <>
                  <VStack
                    key={category.title}
                    align="start"
                    spacing={1}
                    w="full"
                    mb={2}
                  >
                    <Box
                      display="flex"
                      flexDirection="row"
                      justifyContent="space-between"
                      width="100%"
                      pt={2}
                    >
                      <Heading size="lg" weight="medium">
                        {category.title}
                      </Heading>
                      {category.expandLinkText && (
                        <Button
                          variant="link"
                          onClick={category.onExpandLinkClick}
                          size="md"
                        >
                          {category.expandLinkText}
                        </Button>
                      )}
                    </Box>
                    {category.videos.map((video) => (
                      <SelectVideoButton
                        key={video.id}
                        video={video}
                        onClick={() =>
                          onVideoSelect(video, {
                            isTopLevelDrawerOpen: true,
                            isPageSpecificDrawerOpen: isOpen,
                          })
                        }
                      />
                    ))}
                  </VStack>
                  {index < videoCategories.length - 1 ? <Divider /> : null}
                </>
              ))
            : null}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default PageSpecificContentDrawer;
